module.exports = __webpack_public_path__ + "img/googleIcon.60bd1e2d.svg";